import { Card } from "antd";
import styled from "styled-components";

export const Feature = styled.div`
  display: flex;
  align-items: center;
  .feature-icon {
    transform: translateY(1px);
    margin-right: 4px;
  }
  .feature-text {
    color: var(--gray-2);
  }
`;

interface CardStyledProps {
  checked: boolean;
  hasConcierge: boolean;
}

export const CardStyled = styled(Card)<CardStyledProps>`
  position: relative;
  border-radius: 8px;
  transition: 0.3s;
  border-color: ${({ checked }) => (checked ? "var(--ant-primary-color)" : "")};
  background-color: ${({ checked }) => (checked ? "#fbc10512" : "")};
  pointer-events: ${({ hasConcierge }) => (hasConcierge ? "" : "none")};

  &:hover {
    border-color: var(--ant-primary-color);
    transition: 0.3s;
  }
`;

export const GrayOverlay = styled.div`
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: rgba(128, 128, 128, 0.5); /* Cor cinza com transparência */
  pointer-events: none; /* Garante que a camada cinza não intercepte eventos do mouse */
  z-index: 1; /* Coloca a camada cinza acima do conteúdo do card */
`;

export const Interval = styled.p`
  color: var(--ant-primary-color);
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 1rem;

  @media only screen and (max-device-width: 812px) {
    font-size: 12px;
    margin-bottom: 0.5rem;
  }
`;
export const Price = styled.p`
  font-weight: 600;
  font-size: 40px;
  margin: 0;

  @media only screen and (max-device-width: 812px) {
    font-size: 24px;
    margin-bottom: 0.5rem;
  }
`;
export const Info = styled.p`
  font-size: 13px;
  transform: translateY(-8px);
  margin: 0;
`;

export const Radio = styled.div<{
  checked: boolean;
}>`
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ checked }) =>
    checked ? "var(--ant-primary-color)" : "var(--ghost)"};
`;
